import "./App.css";
import MainPage from "./components/mainPage/MainPage";

function App() {
  return <MainPage />;
}

export default App;
